<template>
	<div class="select-outer-wrap">
		<div class="select-inner-wrap">
			<img :src="image" alt />
			<div @mousedown="handleMouseClickStart" class="overlay" ref="overlay">
				<div
					@mousedown.stop="startTranslateExistingDiv($event, i)"
					v-for="(item, i) in selection"
					:key="i"
					:style="getStyle(item.coords)"
					:class="{'no-events': isSelecting, 'has-content': item.content}"
				>
					<div class="edit-links" v-if="!isSelecting && changelink" @mousedown.stop="clickedElement(i)">
						<span class="material-icons">link</span>
					</div>
					<span
						class="material-icons"
						v-if="!isSelecting"
						@mousedown.stop
						@click.stop="deleteItem(i)"
					>clear</span>
					<div class="right" v-if="!isSelecting" @mousedown.stop="startResizeX($event, i)"></div>
					<div class="bottom" v-if="!isSelecting" @mousedown.stop="startResizeY($event, i)"></div>
					<div class="corner" v-if="!isSelecting" @mousedown.stop="startResizeXY($event, i)"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
const MIN_WIDTH_HEIGHT = 2;
const TYPE = {
	del: 'delete',
	mov: 'move',
	res: 'resize',
	cre: 'create'
}
export default {
	data() {
		return {
			isSelecting: false,
			count: 0,
			startMoveCoords: null,
			startMoveDivPosition: null,
			selection: []
		};
	},
	props: {
		image: String,
		selected: Array,
		changelink: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		selected: {
			deep: true,
			handler(val) {
				this.selection = [...val];
			}
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		async init() {
			if (this.selected) this.selection = [...this.selected];
		},
		getStyle(coords) {
			if (coords) {
				let obj = {
					top: coords.top + "%",
					bottom: 100 - coords.bottom + "%",
					left: coords.left + "%",
					right: 100 - coords.right + "%"
				};
				return obj;
			}
		},
		clickedElement(index) {
			let item = this.selection[index];
			let obj = {
				index: index,
				item: item
			};
			this.$emit("select", obj);
		},
		startTranslateExistingDiv(e, index) {
			this.isSelecting = true;

			let startX = e.clientX;
			let startY = e.clientY;
			this.startMoveCoords = {
				x: startX,
				y: startY
			};
			this.startMoveDivPosition = this.selection[index].coords;
			document["__index__"] = index;
			document.addEventListener("mousemove", this.moveElement);
			document.onmouseup = () => {
				document.removeEventListener("mousemove", this.moveElement);
				document.onmouseup = null;
				delete document["__index__"];
				this.isSelecting = false;
				this.startMoveDivPosition = null;
				this.startMoveCoords = null;
				this.save(TYPE['mov'], index);
			};
		},
		moveElement(e) {
			let current = {
				x: e.clientX,
				y: e.clientY
			};
			let start = this.startMoveCoords;
			let index = document["__index__"];

			let overlayDiv = this.$refs["overlay"].getBoundingClientRect();
			let divW = overlayDiv.width;
			let divH = overlayDiv.height;

			let difX = current.x - start.x;
			let difY = current.y - start.y;

			let difXPerc = (difX * 100) / divW;
			let difYPerc = (difY * 100) / divH;

			let translateAmount = {
				x: difXPerc,
				y: difYPerc
			};

			this.translateSpecific(index, translateAmount);
		},
		translateSpecific(index, translateAmount) {
			let shouldUpdate = true;
			function checkForOutOfBounds(number) {
				number = Number(number);
				if (number > 100 || number < 0) shouldUpdate = false;
				return number;
			}
			let newCoords = {
				top: checkForOutOfBounds(
					(
						Number(this.startMoveDivPosition.top) + Number(translateAmount.y)
					).toFixed(2)
				),
				bottom: checkForOutOfBounds(
					(
						Number(this.startMoveDivPosition.bottom) + Number(translateAmount.y)
					).toFixed(2)
				),
				left: checkForOutOfBounds(
					(
						Number(this.startMoveDivPosition.left) + Number(translateAmount.x)
					).toFixed(2)
				),
				right: checkForOutOfBounds(
					(
						Number(this.startMoveDivPosition.right) + Number(translateAmount.x)
					).toFixed(2)
				)
			};
			if (shouldUpdate) this.setCoords(index, newCoords);
		},
		resizeSpecific(index, amount, type) {
			let shouldUpdate = true;
			function checkForOutOfBounds(number) {
				number = Number(number);
				if (number > 100 || number < 0) shouldUpdate = false;
				return number;
			}

			let newCoords = { ...this.startMoveDivPosition };

			if (type === "right")
				newCoords.right = checkForOutOfBounds(
					(Number(this.startMoveDivPosition.right) + Number(amount.x)).toFixed(
						2
					)
				);
			if (type === "bottom")
				newCoords.bottom = checkForOutOfBounds(
					(Number(this.startMoveDivPosition.bottom) + Number(amount.y)).toFixed(
						2
					)
				);
			if (type === "both") {
				newCoords.right = checkForOutOfBounds(
					(Number(this.startMoveDivPosition.right) + Number(amount.x)).toFixed(
						2
					)
				);
				newCoords.bottom = checkForOutOfBounds(
					(Number(this.startMoveDivPosition.bottom) + Number(amount.y)).toFixed(
						2
					)
				);
			}

			if (shouldUpdate) {
				this.setCoords(index, newCoords);
			}
		},
		startResizeX(e, index) {
			this.isSelecting = true;
			// this reffers to the value of right before we started resize
			this.startMoveCoords = {
				x: e.clientX
			};
			this.startMoveDivPosition = this.selection[index].coords;
			document["__index__"] = index;
			document.addEventListener("mousemove", this.resizeX);
			document.onmouseup = () => {
				document.removeEventListener("mousemove", this.resizeX);
				document.onmouseup = null;
				delete document["__index__"];
				this.isSelecting = false;
				this.startMoveDivPosition = null;
				this.startMoveCoords = null;
				this.save(TYPE['res'], index);
			};
		},
		resizeX(e) {
			let current = {
				x: e.clientX
			};
			let start = this.startMoveCoords;
			let index = document["__index__"];

			let overlayDiv = this.$refs["overlay"].getBoundingClientRect();
			let divW = overlayDiv.width;

			let difX = current.x - start.x;

			let difXPerc = (difX * 100) / divW;

			let resizeAmount = {
				x: difXPerc
			};

			this.resizeSpecific(index, resizeAmount, "right");
		},
		startResizeY(e, index) {
			this.isSelecting = true;
			// this reffers to the value of right before we started resize
			this.startMoveCoords = {
				y: e.clientY
			};
			this.startMoveDivPosition = this.selection[index].coords;
			document["__index__"] = index;
			document.addEventListener("mousemove", this.resizeY);
			document.onmouseup = () => {
				document.removeEventListener("mousemove", this.resizeY);
				document.onmouseup = null;
				delete document["__index__"];
				this.isSelecting = false;
				this.startMoveDivPosition = null;
				this.startMoveCoords = null;
				this.save(TYPE['res'], index);
			};
		},
		resizeY(e) {
			let current = {
				y: e.clientY
			};
			let start = this.startMoveCoords;
			let index = document["__index__"];

			let overlayDiv = this.$refs["overlay"].getBoundingClientRect();
			let divH = overlayDiv.height;

			let difY = current.y - start.y;

			let difYPerc = (difY * 100) / divH;

			let resizeAmount = {
				y: difYPerc
			};

			this.resizeSpecific(index, resizeAmount, "bottom");
		},
		startResizeXY(e, index) {
			this.isSelecting = true;
			// this reffers to the value of right before we started resize
			this.startMoveCoords = {
				x: e.clientX,
				y: e.clientY
			};
			this.startMoveDivPosition = this.selection[index].coords;
			document["__index__"] = index;
			document.addEventListener("mousemove", this.resizeXY);
			document.onmouseup = () => {
				document.removeEventListener("mousemove", this.resizeXY);
				document.onmouseup = null;
				delete document["__index__"];
				this.isSelecting = false;
				this.startMoveDivPosition = null;
				this.startMoveCoords = null;
				this.save(TYPE['res'], index);
			};
		},
		resizeXY(e) {
			let current = {
				x: e.clientX,
				y: e.clientY
			};
			let start = this.startMoveCoords;
			let index = document["__index__"];

			let overlayDiv = this.$refs["overlay"].getBoundingClientRect();
			let divH = overlayDiv.height;
			let divW = overlayDiv.width;

			let difX = current.x - start.x;
			let difY = current.y - start.y;

			let difXPerc = (difX * 100) / divW;
			let difYPerc = (difY * 100) / divH;

			let resizeAmount = {
				x: difXPerc,
				y: difYPerc
			};

			this.resizeSpecific(index, resizeAmount, "both");
		},
		handleMouseClickStart(e) {
			this.isSelecting = true;
			let x = e.layerX;
			let y = e.layerY;
			let h = e.target.clientHeight;
			let w = e.target.clientWidth;

			let wPerc = ((x * 100) / w).toFixed(2);
			let hPerc = ((y * 100) / h).toFixed(2);

			let item = {
				start: {
					wPerc,
					hPerc
				},
				coords: {
					top: hPerc,
					bottom: Number(hPerc) + MIN_WIDTH_HEIGHT,
					left: wPerc,
					right: Number(wPerc) + MIN_WIDTH_HEIGHT
				}
			};
			this.selection.push(item);
			this.$refs["overlay"].addEventListener("mousemove", this.onMouseMove);

			// remove global event listener upon releasing mouse left click
			document.onmouseup = () => {
				this.$refs["overlay"].removeEventListener(
					"mousemove",
					this.onMouseMove
				);
				document.onmouseup = null;
				this.isSelecting = false;
				this.save(TYPE['cre'], this.selection.length - 1);
			};
		},
		onMouseMove(e) {
			let y = e.layerY;
			let x = e.layerX;
			let h = e.target.clientHeight;
			let w = e.target.clientWidth;

			let wPerc = ((x * 100) / w).toFixed(2);
			let hPerc = ((y * 100) / h).toFixed(2);

			let current = {
				wPerc,
				hPerc
			};
			let item = this.selection[this.selection.length - 1];
			let start = item.start;
			try {
				let newCoords = this.makeCoords(start, current);
				this.setCoords(this.selection.length - 1, newCoords);
			} catch (error) {
				// console.warn(error);
			}
		},
		setCoords(index, newCoords) {
			if (newCoords.bottom - newCoords.top < MIN_WIDTH_HEIGHT)
				newCoords.bottom = newCoords.top + MIN_WIDTH_HEIGHT;
			if (newCoords.right - newCoords.left < MIN_WIDTH_HEIGHT)
				newCoords.right = newCoords.left + MIN_WIDTH_HEIGHT;

			this.selection[index].coords = newCoords;
		},
		makeCoords(start, current) {
			if (!start.hPerc || !start.wPerc || !current.wPerc || !current.hPerc)
				throw new Error("Some coords missing");

			let obj = {};
			function mutateObj(key, value) {
				value = Number(value);
				if (value < 0) value = 0;
				if (value > 100) value = 100;
				obj[key] = value;
			}

			if (Number(start.hPerc) >= Number(current.hPerc)) {
				mutateObj("top", current.hPerc);
				mutateObj("bottom", start.hPerc);
			} else {
				mutateObj("top", start.hPerc);
				mutateObj("bottom", current.hPerc);
			}

			if (Number(start.wPerc) >= Number(current.wPerc)) {
				mutateObj("left", current.wPerc);
				mutateObj("right", start.wPerc);
			} else {
				mutateObj("left", start.wPerc);
				mutateObj("right", current.wPerc);
			}
			if (obj) return obj;
			else {
				let error = `Edge case where: \nStart: ${start.hPerc} ${start.wPerc}\nCurrent: ${current.hPerc} ${current.wPerc}`;
				throw new Error(error);
			}
		},
		deleteItem(index) {
			if (this.selection[index].contentItems) {
				this.$emit("delete-content", this.selection[index].contentItems);
			}
			this.selection.splice(index, 1);
			this.save(TYPE['del'], index);
		},
		save(type, index) {
			let obj = {
				data: this.selection.map(item => {
					delete item.start;
					return item;
				}),
				type: type,
				index: index
			}
			this.$emit(
				"save",
				obj
			);
		}
	}
};
</script>

<style lang="scss" scoped>
.select-outer-wrap {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.no-events {
	pointer-events: none;
}
.select-inner-wrap {
	user-select: none;
	position: relative;
	max-height: 100%;
	max-width: 100%;
	img {
		position: relative;
		max-width: 100%;
		max-height: 100%;
	}
	.overlay {
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		position: absolute;
		border: black 2px solid;
		cursor: crosshair;
		div:active {
			cursor: grabbing;
			pointer-events: all;
		}
		div {
			&.has-content {
				background: rgba(0, 187, 255, 0.5);
				.right,
				.bottom,
				.corner {
					background: rgb(78, 181, 218);
				}
			}
			border-radius: 3px;
			cursor: grab;
			position: absolute;
			background: rgba(255, 0, 0, 0.5);
			overflow: hidden;
			span {
				cursor: pointer;
				position: absolute;
				top: 3%;
				right: 3%;
				font-size: 13px;
			}
			.edit-links {
				color: rgba(0, 0, 0, 0.6);
				$size: 30px;
				background: none;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: $size;
				height: $size;
				span {
					font-size: $size;
					display: block;
				}
			}
			.bottom {
				cursor: row-resize;
				position: absolute;
				bottom: 0;
				left: 0;
				height: 4px;
				width: calc(100% - 6px);
				background: rgba(255, 0, 0, 0.612);
			}
			.right {
				cursor: col-resize;
				position: absolute;
				top: 0;
				right: 0;
				width: 4px;
				height: calc(100% - 6px);
				background: rgba(255, 0, 0, 0.612);
			}
			.corner {
				cursor: nwse-resize;
				position: absolute;
				bottom: 0;
				right: 0;
				width: 6px;
				height: 6px;
				border-radius: 3px;
				background: rgba(255, 0, 0, 0.612);
			}
		}
	}
}
</style>